import { classNames, getAvatarColor, getInitials } from '@/lib/format';

interface Props {
  vorname?: string | null;
  nachname?: string | null;
  src?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function Avatar({ vorname, nachname, src, size = 'md' }: Props) {
  const initials = getInitials(vorname, nachname);
  const name = `${vorname ?? ''} ${nachname ?? ''}`.trim() || initials;
  const bg = getAvatarColor(name);
  const cls = classNames('avatar', size !== 'md' && `avatar--${size}`);
  return (
    <span className={cls} style={src ? undefined : { background: bg }}>
      {src ? <img src={src} alt={name} loading="lazy" /> : initials}
    </span>
  );
}
